module.exports = __webpack_public_path__ + "img/PPMPRA11.ee48e0b8.png";